import Vue from 'vue'

export default {

  create (params) {
    return Vue.http.post(
      `${process.vars.BACKEND_HOST}/api/ui/district_codes/`,
      {
        assignment_term_id: params.assignmentTermId,
        zipcodes: params.zipCodesList,
        entire_country: params.entireCountry,
        country_code: params.countryCode
      }
    )
  }
}
